export default "__VITE_ASSET__CzBwsMxK__"